import { getQaSelector } from '../../../../utils/common'
import { Link } from '../../../Link'

import { QA_NAME_BREADCRUMB } from './ListItem.constants'

import * as styles from './ListItem.module.css'

function ListItem({ item, onClickItem }) {
  const { title, to } = item

  const WrapperComponent = to ? Link : 'div'

  const qaProps = getQaSelector({
    value: QA_NAME_BREADCRUMB,
  })

  function handleClick(event) {
    onClickItem?.(item, event)
  }

  return (
    <WrapperComponent
      {...qaProps}
      className={styles.listItem}
      to={to}
      onClick={handleClick}
    >
      <span>{title}</span>
    </WrapperComponent>
  )
}

export default ListItem
